import React from "react";
import { Link } from "react-router-dom";
import "./About.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import sandy from "../../assets/SANDY-RANDHAWA.png";

const About = () => {
  return (
    <div className="page-container">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1>Meet Sandy Randhawa</h1>
          <p className="page-hero-subtitle">
            An Advocate for Fair Outcomes & Supportive Guidance
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="page-content">
        <div className="page-wrapper">
          {/* Image and Intro */}
          <div className="about-intro">
            <div className="about-image-wrapper">
              <img src={sandy} alt="Sandy Randhawa" />
            </div>
            <div className="about-intro-text">
              <h2>Experienced Family & Matrimonial Solicitor</h2>
              <p>
                Sandy Randhawa is an experienced family and matrimonial solicitor who advises on all aspects of divorce, separation and nullity, including the resolution of financial, property and pension issues. Sandy also deals with cases involving an international element, jurisdiction disputes and issues relating to children, injunctions relevant to domestic abuse, and advises on cohabitation issues and pre-marital agreements.
              </p>
              <p>
                She has represented a diverse range of clients both in England and internationally. These clients include footballers, senior company directors, pilots, teachers and police officers.
              </p>
            </div>
          </div>

          {/* Detailed Sections */}
          <div className="about-sections">
            <div className="about-section">
              <h3>Expertise in Complex Financial Disputes</h3>
              <p>
                Sandy has successfully made a name for herself in dealing with complicated financial disputes involving high net worth assets, disputes regarding ownership of property, third party interests and trusts claims. Her understanding of important cultural practices in certain communities has assisted in carefully bringing complicated ownership claims to the court's attention to ensure that she secures excellent results for her clients.
              </p>
            </div>

            <div className="about-section">
              <h3>Client-Centered Approach</h3>
              <p>
                As a Senior Solicitor with years of experience, Sandy prides herself on treating each case individually and reaching a conclusion as sensitively and speedily as possible. She recognises that relationship breakdown is a very difficult and emotionally challenging time for clients and therefore provides as much support and understanding as possible. Sandy's philosophy is to deal with matters in a conciliatory manner, whilst adopting a no nonsense approach to secure the best outcome for her clients.
              </p>
            </div>

            <div className="about-section">
              <h3>Professional Memberships & Recognition</h3>
              <p>
                As well as being a member of Resolution (formerly known as SFLA), Sandy is an accredited member of the Law Society's Family Law Panel and a member of the Middlesex Law Society, having previously been the Lecture Secretary for the Buckinghamshire, Berkshire and Oxfordshire Law Society. She is also on the management committee for Slough Contact Centre.
              </p>
            </div>

            <div className="about-section">
              <h3>Media Presence & Community Engagement</h3>
              <p>
                Having appeared on television and radio, Sandy is regularly invited to deliver presentations to various organisations. She has worked closely with local courts and Judges in presenting topical issues to practitioners and Judges. She is currently involved in hosting workshops for other professionals to raise awareness of the issues facing family and matrimonial clients. She also undertakes pro-bono work in the local community.
              </p>
            </div>

            <div className="about-section">
              <h3>Multilingual Services</h3>
              <p>
                Sandy is fluent in Punjabi, Hindi and Urdu, enabling her to serve a diverse client base and provide culturally sensitive legal representation.
              </p>
            </div>
          </div>

          {/* What Sets Sandy Apart */}
          <div className="about-highlights">
            <h2>What Sets Sandy Apart</h2>
            <div className="highlights-grid">
              <div className="highlight-card">
                <div className="highlight-icon"><i className="fa-solid fa-user-tie"></i></div>
                <h4>Personalised Approach</h4>
                <p>Client-focused service tailored to your unique situation</p>
              </div>
              <div className="highlight-card">
                <div className="highlight-icon"><i className="fa-solid fa-file-lines"></i></div>
                <h4>Clear Guidance</h4>
                <p>Honest, realistic advice at every step of your journey</p>
              </div>
              <div className="highlight-card">
                <div className="highlight-icon"><i className="fa-solid fa-scale-balanced"></i></div>
                <h4>Strong Negotiator</h4>
                <p>Experienced in both negotiation and court representation</p>
              </div>
              <div className="highlight-card">
                <div className="highlight-icon"><i className="fa-solid fa-handshake"></i></div>
                <h4>Constructive Resolution</h4>
                <p>Committed to resolving disputes with minimum stress</p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="page-cta">
            <h2>Ready to Work Together?</h2>
            <p>Book a free consultation to discuss your case</p>
            <Link to="/contact" className="cta-button">
              Get in Touch
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
